import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const getContentSectionsList = async () => {
  return await axiosInstance.get("homepage/content-sections/getlist", {
    headers,
  });
};

export const getContentSectionById = async (id) => {
  const response = await axiosInstance.get(
    `homepage/content-sections/get/${id}`,
    { headers }
  );
  return response.data.result;
};

export const addContentSection = async (payload) => {
  return await axiosInstance.post("homepage/content-sections/add", payload, {
    headers,
  });
};

export const updateContentSection = async (payload) => {
  return await axiosInstance.put("homepage/content-sections/update", payload, {
    headers,
  });
};

export const deleteContentSection = async (id) => {
  return await axiosInstance.delete(
    `homepage/content-sections/delete/${id}`,
    { headers }
  );
};
